import type { FC } from 'react';

import { Modal } from '@polyai/ui/components/molecules/Modal';

import useExtendTrial from 'hooks/useExtendTrial';

interface ExtendTrialModalProps {
  open: boolean;
  onClose: () => void;
}

const ExtendTrialModal: FC<ExtendTrialModalProps> = ({ open, onClose }) => {
  const { extendTrial, isLoading } = useExtendTrial();

  const handleExtend = async () => {
    await extendTrial();
    onClose();
  };

  return (
    <Modal.Root open={open} onOpenChange={isOpen => !isOpen && onClose()}>
      <Modal.Content size="sm">
        <Modal.Title>Need some more time?</Modal.Title>
        <p className="text-fg-secondary text-body-regular">
          Extend your trial by 30 days to finish setting up and testing your
          agent. This extension is available once per workspace.
        </p>
        <Modal.Footer
          dismiss={{
            label: 'Cancel',
            onClick: onClose,
          }}
          primary={{
            label: 'Extend trial',
            onClick: handleExtend,
            loading: isLoading,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};

export default ExtendTrialModal;
